import { ComponentType } from "react";
import { BLOCK } from "./blockTypes";
import AudioBlock from "./blocks/AudioBlock";
import { DelimiterBlock, EmbedBlock } from "./blocks/BasicBlocks";
import CalloutBlock from "./blocks/CalloutBlock";
import CardListBlock from "./blocks/CardListBlock";
import CtaButtonBlock from "./blocks/CtaButtonBlock";
import HeroBlock from "./blocks/HeroBlock";
import IconLinksBlock from "./blocks/IconLinksBlock";
import IframeBlock from "./blocks/IframeBlock";
import ImageBlock from "./blocks/ImageBlock";
import QuoteBlock from "./blocks/QuoteBlock";
import SpacerBlock from "./blocks/SpacerBlock";
import TableBlock from "./blocks/TableBlock";
import { HeaderBlock, ListBlock, ParagraphBlock } from "./blocks/TextBlocks";
import VideoBlock from "./blocks/VideoBlock";
import VideoCardsBlock from "./blocks/VideoCardsBlock";

/**
 * type -> design-system component. Every component takes exactly {data} (the block's
 * data as the API returns it, language already resolved). Unknown types are skipped by
 * the renderer — the API passes future types through, old app versions just don't show
 * them, they never crash.
 */
export type BlockComponent = ComponentType<{ data: any }>;

const REGISTRY: Record<string, BlockComponent> = {
  [BLOCK.HEADER]: HeaderBlock,
  [BLOCK.PARAGRAPH]: ParagraphBlock,
  [BLOCK.LIST]: ListBlock,
  [BLOCK.TABLE]: TableBlock,
  [BLOCK.DELIMITER]: DelimiterBlock,
  [BLOCK.EMBED]: EmbedBlock,
  [BLOCK.IMAGE]: ImageBlock,
  [BLOCK.HERO]: HeroBlock,
  [BLOCK.ICON_LINKS]: IconLinksBlock,
  [BLOCK.CARDS]: CardListBlock,
  [BLOCK.CTA_BUTTON]: CtaButtonBlock,
  [BLOCK.AUDIO]: AudioBlock,
  [BLOCK.VIDEO]: VideoBlock,
  [BLOCK.VIDEO_CARDS]: VideoCardsBlock,
  [BLOCK.IFRAME]: IframeBlock,
  [BLOCK.SPACER]: SpacerBlock,
  [BLOCK.CALLOUT]: CalloutBlock,
  [BLOCK.QUOTE]: QuoteBlock,
};

export const getBlockComponent = (type: string): BlockComponent | undefined => REGISTRY[type];
